import * as React from "react";
import Button from "@mui/material/Button";
import { styled } from "@mui/material/styles";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import Typography from "@mui/material/Typography";
import TextareaAutosize from "@mui/material/TextareaAutosize";
import Box from "@mui/material/Box";
import WhatsappIcon from "@mui/icons-material/WhatsApp";
import TelegramIcon from "@mui/icons-material/Telegram";
import Snackbar from "@mui/material/Snackbar";
import CopyIcon from "@mui/icons-material/CopyAll";
import GenericUtil from "./../../util/Generic";
import ApiCommonContent from "../../services/GenericContent";

import { TelegramShareButton, WhatsappShareButton } from "react-share";

import "./styles.scss";
import { ButtonTypes, CommonContent, ContentKey } from "../../types/Types";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
}));

export interface DialogTitleProps {
  id: string;
  children?: React.ReactNode;
  onClose: () => void;
}

type Props = {
  visible: boolean;
  gameId: string;
  content: CommonContent[];
  onCloseInvite: () => void;
};

function BootstrapDialogTitle(props: DialogTitleProps) {
  const { children, onClose, ...other } = props;
  return (
    <DialogTitle sx={{ m: 0, p: 2 }} {...other} className="backgroundAzul">
      {children}
      {onClose ? (
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </DialogTitle>
  );
}

export default function ShareGame(props: Props) {
  const [open, setOpen] = React.useState(false);
  const [urlCopied, setUrlCopied] = React.useState(false);
  const shareInputRef = React.useRef<HTMLTextAreaElement>(null);
  const urlToShare = `${GenericUtil.getBaseURL()}/?gameId=${props.gameId}`;

  const copiedText = ApiCommonContent.getKeyValue(
    props.content,
    ContentKey.CONTENT_CIPIED
  );

  const handleClick = () => {
    setOpen(true);
  };

  const handleClose = (
    event: React.SyntheticEvent | Event,
    reason?: string
  ) => {
    if (reason === "clickaway") {
      return;
    }

    setOpen(false);
  };

  const copyToClipboard = (): void => {
    if (!navigator.clipboard && shareInputRef.current) {
      shareInputRef.current.select();
      shareInputRef.current.setSelectionRange(0, 99999);
    } else {
      if (shareInputRef.current) {
        navigator.clipboard
          .writeText(shareInputRef.current.value)
          .then(() => {
            setUrlCopied(true);
            setOpen(true);
          })
          .catch((e) => {
            alert(e);
          });
      }
    }
  };

  console.log("Share content:", props.content);

  const action = (
    <React.Fragment>
      <IconButton
        size="small"
        aria-label="close"
        color="inherit"
        onClick={handleClose}
      >
        <CloseIcon fontSize="small" />
      </IconButton>
    </React.Fragment>
  );

  return (
    <Box>
      <BootstrapDialog
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={props.visible}
      >
        <BootstrapDialogTitle
          id="customized-dialog-title"
          onClose={props.onCloseInvite}
        >
          {ApiCommonContent.getKeyValue(
            props.content,
            ContentKey.INVITE_PLAYERS
          )}
        </BootstrapDialogTitle>
        <DialogContent className="backgroundAzul" dividers>
          <Typography gutterBottom>
            {ApiCommonContent.getKeyValue(
              props.content,
              ContentKey.INVITE_PLAYERS_DESCRIPTION
            )}
            <p>
              {" "}
              {ApiCommonContent.getKeyValue(props.content, ContentKey.LINK)}
            </p>
          </Typography>

          <TextareaAutosize
            ref={shareInputRef}
            style={{ width: "100%" }}
            className="URLTextDialog"
            value={urlToShare}
          />
          <div>
            <Button
              onClick={() => {
                copyToClipboard();
              }}
              startIcon={<CopyIcon />}
            >
               {ApiCommonContent.getKeyValue(
              props.content,
              ContentKey.COPY_GAME_LINK
            )}
            </Button>
          </div>
        </DialogContent>
        <DialogActions className="backgroundAzul">
          <Button autoFocus onClick={props.onCloseInvite}>
            {ApiCommonContent.getButtonName(
              props.content,
              ButtonTypes.CONTINUE
            )}
          </Button>
        </DialogActions>
      </BootstrapDialog>
      <div>
        <Snackbar
          open={open}
          autoHideDuration={60000}
          onClose={handleClose}
          message={copiedText}
          action={action}
        />
      </div>
    </Box>
  );
}
